<app-checkout-layout
  [title]="'checkout.billing_address.title' | translate"
  [description]="'checkout.billing_address.description' | translate"
  [backLinkAriaLabel]="'checkout.payment.back_link' | translate"
  [backLink]="backLink"
  [hasLargeColumn]="true"
  data-test="billing-address-page"
>
  <form [formGroup]="addressForm" (ngSubmit)="onSubmit()">
    <!-- Address -->
    <app-form-input-group
      class="block mb-3"
      [label]="'checkout.billing_address.street_address.label' | translate"
      [errors]="errors('streetAddress')"
      errorKey="streetAddress"
    >
      <app-form-input
        formControlName="streetAddress"
        #content
        type="text"
        [placeholder]="
          'checkout.billing_address.street_address.placeholder' | translate
        "
        [required]="true"
        data-test="billing-address-address"
      ></app-form-input>
    </app-form-input-group>

    <!-- Postal Code -->
    <app-form-input-group
      [label]="'checkout.billing_address.postal_code.label' | translate"
      class="block mb-3"
      [errors]="errors('postalCode')"
      errorKey="postalCode"
    >
      <app-form-input
        formControlName="postalCode"
        #content
        class="block w-full md:w-1/3"
        type="text"
        [placeholder]="
          'checkout.billing_address.postal_code.placeholder' | translate
        "
        [required]="true"
        data-test="billing-address-postal-code"
      ></app-form-input>
    </app-form-input-group>

    <!-- City -->
    <app-form-input-group
      [label]="'checkout.billing_address.address_locality.label' | translate"
      class="block mb-4"
      [errors]="errors('addressLocality')"
      errorKey="addressLocality"
    >
      <app-form-input
        formControlName="addressLocality"
        #content
        type="text"
        [placeholder]="
          'checkout.billing_address.address_locality.placeholder' | translate
        "
        [required]="true"
        data-test="billing-address-address-locality"
      ></app-form-input>
    </app-form-input-group>

    <!-- Country -->
    <app-form-input-group
      [label]="'checkout.billing_address.country.label' | translate"
      class="block mb-4"
      [errors]="errors('addressCountry')"
      errorKey="addressCountry"
    >
      <app-form-dropdown-country
        formControlName="addressCountry"
        #content
        data-test="billing-address-country"
      ></app-form-dropdown-country>
    </app-form-input-group>

    <!-- Submit -->
    <app-mobile-fixed-panel [parentElementRef]="appBillingAddressElementRef">
      <button
        app-vtmn-play-button
        type="submit"
        [class.w-full]="isMobileDevice"
        [type]="ctaButtonType.Submit"
        [size]="vtmnPlayButtonSize.MEDIUM"
        [size]="
          isMobileDevice
            ? vtmnPlayButtonShape.SQUARED
            : vtmnPlayButtonShape.ROUNDED
        "
        [disabled]="addressForm.invalid ? true : null"
        [attr.data-disabled]="addressForm.invalid ? true : null"
        data-test="submit-billing-address-form"
      >
        {{ 'checkout.billing_address.continue' | translate }}
      </button>
    </app-mobile-fixed-panel>

    <app-tips
      class="block md:mt-4"
      [title]="'checkout.billing_address.why' | translate"
      [tips]="'checkout.billing_address.because' | translate"
    >
    </app-tips>
  </form>
</app-checkout-layout>
